// #3642 -- the floating corner Gear + Lock buttons (AppShell) are fixed at
// the bottom right of every screen, 40px wide each, 8px apart, 12px in from
// the edge. Anything pinned to the bottom edge (the scoring footer) reserves
// this much right space so none of its controls can sit under them: a tap
// near the right of Complete & Sign used to lock the screen or open the
// admin PIN dialog mid-signing.
export const CORNER_BUTTON_SIZE = 40;
export const CORNER_BUTTON_GAP = 8;
export const CORNER_BUTTON_EDGE = 12;
// Gear + Lock, and one gap of clearance left of the Gear.
export const CORNER_BUTTONS_RESERVED_WIDTH =
  CORNER_BUTTON_EDGE + CORNER_BUTTON_SIZE + CORNER_BUTTON_GAP + CORNER_BUTTON_SIZE + CORNER_BUTTON_GAP;
